import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { UserListQuery } from '@/api/handlers/resources/users/requests';
import type { GetUsersResponse } from '@/api/handlers/resources/users/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { UserQueryKeys } from './userQueryKeys';

/**
 * Reads `GET /api/v1/users` (server-paginated). The Team page passes an explicit
 * page / pageSize / search; a BranchAdmin is auto-scoped to their branch
 * server-side, so `branchId` is only sent for an OrgAdmin's per-branch filter.
 */
export const useUsersQuery = (query: UserListQuery, enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetUsersResponse>>({
        queryKey: UserQueryKeys.listPage(query),
        queryFn: () => apiClient.users.getUsers(query),
        enabled,
        staleTime: 60_000,
        // Keep the current page on screen while the next one loads so paging
        // doesn't flash the skeleton.
        placeholderData: keepPreviousData,
    });
};
